module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "cen_f"
  }, [_vm._v("‘"), _c('em', [_vm._v("Far Field")]), _vm._v(" is the stunning culmination of a hugely ambitious trilogy celebrating Carruth’s love for a rural landscape and its people. In essence, think of "), _c('em', [_vm._v("A Scots Quair")]), _vm._v(" as enduring song. I cannot think of any other collection which so intimately and sensitively documents a beloved corner of a beloved country and the folk who farmed there, through all their seasons and weathers.’")]), _vm._v(" "), _c('p', {
    staticClass: "cen_f1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("JOHN GLENDAY")])]), _vm._v(" "), _c('p', {
    staticClass: "cen_f"
  }, [_vm._v("‘In deeply moving poems, as fierce as they are tender, Carruth honours a way of life that is threatened or already lost. His vivid language immerses us in the daily work of caring for animals, fields, family and neighbours. Every line is as honed as the landscape, evoking the harrowing, relentless aspects of farming as well as the meaning and beauty to be found in everyday routines. Endurance is threaded through the collection as is love and the potential for regeneration.’")]), _vm._v(" "), _c('p', {
    staticClass: "cen_f1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("JANE CLARKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cen_f"
  }, [_vm._v("‘"), _c('em', [_vm._v("Far Field")]), _vm._v(" completes Jim Carruth’s marvellous trilogy that began with "), _c('em', [_vm._v("Black Cart")]), _vm._v(" and "), _c('em', [_vm._v("Bale Fire")]), _vm._v(". I am in awe of his verbal power and the author’s fidelity to love, loss, and community. This is a book of land and landscapes, and the gift of being alive to them.’")]), _vm._v(" "), _c('p', {
    staticClass: "cen_f1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("DAVID MORLEY")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bf2396a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 60
// module chunks = 0